import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Suspense } from "react";
import ContentBox from "../../ContentBox";
import ContentListItem from "../../ContentListItem";
import { List, Divider, Box } from "@material-ui/core";
import { LinkItemResource } from "@ploy-lib/rest-resources";
import { useCache } from "@rest-hooks/core";
import Skeleton from "@material-ui/lab/Skeleton";
import Pagination from "@material-ui/lab/Pagination";
import { useMaxItems } from "../../hooks/useMaxItems";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import { LinkListItems } from "./LinkListItems";
import { defineMessages } from "react-intl";
export const sources = [
    "linksForVendor",
    "productInfoForUser"
];
export const sourceMapTitles = defineMessages({
    linksForVendor: {
        id: "dploy.grid.links.source.option.linksForVendor.label",
        defaultMessage: "Links for vendor"
    },
    productInfoForUser: {
        id: "dploy.grid.links.source.option.productInfoForUser.label",
        defaultMessage: "Product info for user"
    }
});
const Links = props => {
    const { boxProps, emptyMessage, source, placeholder } = props;
    const links = useCache(...resources(props)[0]);
    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        setPage(value);
    };
    const [listRef, pageSize] = useMaxItems({
        itemHeight: 36,
        divider: true,
        wait: 500
    });
    // const pageSize = 4;
    const animation = !placeholder && undefined;
    const fallback = (_jsxs(_Fragment, { children: [_jsx(ContentListItem, { primary: _jsx(Skeleton, { animation: animation, variant: "text", width: "80%" }), chevronIcon: _jsx(OpenInNewIcon, { fontSize: "small" }) }), _jsx(Divider, {}), _jsx(ContentListItem, { primary: _jsx(Skeleton, { animation: animation, variant: "text", width: "80%" }), chevronIcon: _jsx(OpenInNewIcon, { fontSize: "small" }) })] }));
    return (_jsx(ContentBox, { ...boxProps, actions: links && pageSize && links.length > pageSize ? (_jsx(Pagination, { count: Math.ceil(links?.length / pageSize), page: page, onChange: handleChange })) : null, children: _jsx(Box, { height: "100%", clone: true, children: _jsx(List, { component: "nav", dense: true, ref: listRef, children: placeholder ? (fallback) : (_jsx(Suspense, { fallback: fallback, children: _jsx(LinkListItems, { page: page, pageSize: pageSize, source: source, emptyMessage: emptyMessage, placeholder: placeholder }) })) }) }) }));
};
export const resources = ({ source }) => [
    [
        source && LinkItemResource[source]
            ? LinkItemResource[source]()
            : LinkItemResource.list(),
        source ? {} : null
    ]
];
Links.getPrefetch = resources;
Links.getVisibilityFetch = resources;
Links.getVisibility = (props, [links]) => links != null && links.length > 0;
Links.displayName = "DployDashboardLinks";
export default Links;
//# sourceMappingURL=Links.js.map